// Small composite "have we touched this person?" indicator: a phone
// glyph + an envelope glyph, green when present / ghost when absent,
// with a single title tooltip. Minimal visual weight so it can sit on
// any listing row (AOI roster, pool order buckets, lead list, party
// header, Wyoming rosters, search hits) and read identically everywhere.

interface Props {
  hasPhone: boolean;
  hasAddress: boolean;
  /** Extra classes for layout (margins, alignment) at the call site. */
  className?: string;
}

export function HasContactIndicator({ hasPhone, hasAddress, className }: Props) {
  const title =
    `${hasPhone ? 'Phone on file' : 'No phone'} · ` +
    `${hasAddress ? 'address on file' : 'no address'}`;
  return (
    <span
      className={'inline-flex items-center gap-0.5 leading-none ' + (className ?? '')}
      title={title}
      aria-label={title}
    >
      <span className={'text-[10px] ' + (hasPhone ? 'text-green' : 'text-text-ghost')}>☎</span>
      <span className={'text-[10px] ' + (hasAddress ? 'text-green' : 'text-text-ghost')}>✉</span>
    </span>
  );
}
